import { Center, Paper, Stack, Text, Title } from "@mantine/core";
import type { ReactNode } from "react";

/** Centered card for the signed-out screens. */
export function AuthCard({
  title,
  subtitle,
  children,
  width = 420,
}: {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  width?: number;
}) {
  return (
    <Center mih="100vh" p="md">
      <Stack w="100%" maw={width} gap="lg">
        <Text ta="center" fw={700} size="lg">
          Fireslot{" "}
          <Text span c="violet.4" fw={700}>
            Back Office
          </Text>
        </Text>
        <Paper withBorder p="xl" radius="md" shadow="md">
          <Title order={3} mb={subtitle ? 4 : "md"}>
            {title}
          </Title>
          {subtitle && (
            <Text c="dimmed" size="sm" mb="md">
              {subtitle}
            </Text>
          )}
          {children}
        </Paper>
      </Stack>
    </Center>
  );
}
